/* eslint-disable no-nested-ternary */
import React, { FC } from 'react';
import styled from 'styled-components';

import getImgxUrl from 'Jsx/Utils/getImgxUrl';
import LazyImageV2 from 'Jsx/Shared/LazyImageV2';

import Avatar from 'crehana-ui/Avatar';
import Crehanaicons32 from 'crehana-icons/Crehanaicons32';

import { ProjectType } from '../types';

const Information = styled.div`
  display: none;
  @media (min-width: 768px) {
    display: block;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    padding: 16px;
    height: 195px;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 30%;
    z-index: 2;

    .content-like {
      opacity: 0;
      height: 0;
      transition: all 0.3s ease-in;
    }
  }
`;

const ImageWrapper = styled.button<{ isShowMore }>`
  height: 215px;
  width: 215px;
  display: block;
  margin-bottom: 10px;
  .project-image {
    height: 215px;
    @media (min-width: 768px) {
      height: 195px;
    }
  }
  @media (min-width: 768px) {
    position: relative;
    width: 100%;
    height: 250px;
    &:hover {
      ${Information} {
        .content-like {
          opacity: 1;
          height: 20px;
        }
      }
    }

    &:before {
      content: '';
      width: 100%;
      height: ${({ isShowMore }) => (isShowMore ? '100%' : '35%')};
      bottom: 0;
      left: 0;
      position: absolute;
      background: linear-gradient(
        180deg,
        rgba(24, 27, 50, 0.85) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      transform: rotate(-180deg);
      z-index: 1;
    }
  }
  @media (min-width: 1024px) {
    height: 140px;
    .project-image {
      height: 140px;
    }
  }

  .is-show-more-button {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2;
  }
`;

type ProjectCardAThemeProps = {
  inSlider?: boolean;
  isShowMore?: boolean;
  numRestItems?: number;
  project: ProjectType;
  showMoreProjects?: (() => void) | undefined;
};

const ProjectCardATheme: FC<ProjectCardAThemeProps> = ({
  project: {
    projectImageUrl,
    likes,
    url: projectUrl,
    user: { username, profileUrl, profilePictureUrl },
  },
  isShowMore,
  numRestItems,
  showMoreProjects,
}) => {
  const imageUrl =
    projectImageUrl === null
      ? window.STATIC_URL
        ? `${window.STATIC_URL}img/course-detail/project-default-3.jpg`
        : '/static/img/course-detail/project-default-3.jpg'
      : projectImageUrl;

  const redirectOrShowMore = () => {
    if (isShowMore) {
      showMoreProjects();
      return;
    }
    window.open(projectUrl, '_blank');
  };

  return (
    <div>
      <ImageWrapper
        isShowMore={isShowMore}
        type="button"
        onClick={() => redirectOrShowMore()}
      >
        <LazyImageV2
          bgColor="#d3d3d3b3"
          lazyUrl={imageUrl}
          imgxParams={{
            w: 195,
            h: 195,
          }}
        />
        {isShowMore ? (
          <div className="is-show-more-button">
            <p className="font-h1 text-white">+{numRestItems}</p>
          </div>
        ) : (
          <Information>
            <div className="flex items-center">
              <Avatar
                size={24}
                src={getImgxUrl(profilePictureUrl, {
                  w: 24,
                  h: 24,
                  crop: 'faces',
                })}
                href={profileUrl}
                target="_blank"
                rel="noopener noreferrer"
                aProps={{
                  'aria-label': profileUrl,
                }}
              />
              <a
                aria-label="Perfil del alumno"
                href={profileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="ml-4"
              >
                <span className="font-bold font-body4 text-white">
                  {username}
                </span>
              </a>
            </div>
            <div className="flex items-center mt-8 content-like">
              <Crehanaicons32 size={16} color="#fff" className="mr-4" />
              <span className="font-bold font-body4 text-white">{likes}</span>
            </div>
          </Information>
        )}
      </ImageWrapper>
    </div>
  );
};

export default ProjectCardATheme;
